// utils/invoiceCalculations.ts
export interface InvoiceTotals {
  totalSales: number;
  paidAmount: number;
  unpaidAmount: number;
  partialPaidAmount: number;
}

/**
 * Calculate invoice totals from an array of invoices
 * This calculates totals from ALL invoices, not filtered ones
 */
export const calculateInvoiceTotals = (invoices: any[]): InvoiceTotals => {
  return invoices.reduce((acc, invoice) => {
    acc.totalSales += invoice.totalAmount || 0;
    
    switch(invoice.status?.toUpperCase()) {
      case 'PAID':
        acc.paidAmount += invoice.totalAmount || 0;
        break;
      case 'UNPAID':
        acc.unpaidAmount += invoice.totalAmount || 0;
        break;
      case 'PARTIAL_PAID':
        acc.partialPaidAmount += invoice.totalAmount || 0;
        break;
    }
    
    return acc;
  }, { 
    totalSales: 0, 
    paidAmount: 0, 
    unpaidAmount: 0, 
    partialPaidAmount: 0 
  });
};

/**
 * Calculate totals from filtered invoices (for display purposes)
 */
export const calculateFilteredTotals = (invoices: any[], filters: any): InvoiceTotals => {
  const filteredInvoices = invoices.filter(invoice => {
    // Apply filters
    if (filters.status && invoice.status !== filters.status) return false;
    if (filters.gstType && invoice.gstType !== filters.gstType) return false;
    // Add more filters as needed
    return true;
  });
  
  return calculateInvoiceTotals(filteredInvoices);
};

/**
 * Format currency for display
 */
export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(amount);
};